import { LANDING_PAGE_CONTENT_MAX_WIDTH } from 'app/components/web/dashboard-layout-constants';
import { createTheme as createDSTheme } from 'app/shopify';
import { StyleSheet } from 'react-native';

export const landingPageLargeTheme = createDSTheme();

export const landingPageLargeStyles = StyleSheet.create({
  page: {
    alignSelf: 'center',
    maxWidth: LANDING_PAGE_CONTENT_MAX_WIDTH,
    paddingTop: landingPageLargeTheme.spacing['spacing.general.x8'],
    paddingBottom: landingPageLargeTheme.spacing['spacing.general.x8'],
    width: '100%',
  },
  scrollView: {
    minHeight: 0,
    width: '100%',
  },
  scrollViewContent: {
    flexGrow: 1,
  },
  headerIcon: {
    fontSize: 28,
    marginLeft: landingPageLargeTheme.spacing['spacing.general.x1'],
  },
});
